import React from 'react';
import { Weight, Flame, Dumbbell, Activity } from 'lucide-react';

const Specialties = () => {
  return (
    <section className="py-16 bg-white" id="specialties">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Coach HT <span className="text-primary-500">Specializes</span> In
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {/* Specialty 1 */}
          <div className="text-center">
            <div className="bg-primary-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Flame className="text-primary-500" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Fat Loss</h3>
            <p className="text-gray-700">
              Effective fat loss programs using the PHYT method
            </p>
          </div>

          {/* Specialty 2 */}
          <div className="text-center">
            <div className="bg-primary-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Weight className="text-primary-500" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Form & Alignment</h3>
            <p className="text-gray-700">
              Proper form and alignment for safe, effective workouts
            </p>
          </div>

          {/* Specialty 3 */}
          <div className="text-center">
            <div className="bg-primary-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Dumbbell className="text-primary-500" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">PHYT Method</h3>
            <p className="text-gray-700">
              The proven PHYT method for faster results
            </p>
          </div>

          {/* Specialty 4 */}
          <div className="text-center">
            <div className="bg-primary-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6">
              <Activity className="text-primary-500" size={32} />
            </div>
            <h3 className="font-bold text-xl mb-3 text-gray-900">Nutrition Coaching</h3>
            <p className="text-gray-700">
              Comprehensive nutrition guidance and meal planning
            </p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <a
            href="#packages"
            className="inline-block bg-primary-500 text-white text-lg px-8 py-4 rounded-xl hover:bg-primary-600 transition duration-300 shadow-lg"
          >
            View Programs
          </a>
        </div>

        <div className="mt-16 bg-primary-50 p-8 rounded-xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center text-gray-900">
            Who Coach HT <span className="text-primary-500">Works With</span>
          </h3>
          <p className="text-xl text-center text-gray-700 max-w-3xl mx-auto">
          Coach HT works with primarily female clients of all levels, from beginners to advanced, helping them achieve their health and fitness goals through the PHYT Method, a training method that focuses on proper form and alignment, strength, mobility, and flexibility.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-primary-500">Fitness Beginners</h4>
              <p className="text-gray-700">
                Perfect for those just starting their fitness journey with proper guidance
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-primary-500">Busy Professionals</h4>
              <p className="text-gray-700">
                Efficient workouts and nutrition plans that fit into your schedule
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-sm">
              <h4 className="font-bold text-lg mb-2 text-primary-500">Women's Fitness</h4>
              <p className="text-gray-700">
                Specialized programs focused on women's health and fitness needs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialties;